import React, { useState, useEffect, useRef } from 'react';
import { AppContext } from '@quotient/riq-state';
import { generateSignInLink } from '@quotient/riq-helpers';
import { signOut } from '../api';

interface INavTabProps {
  setHeaderClass: (className?: string) => void;
}

const NavTab = ({ setHeaderClass }: INavTabProps) => {
  const { appState }: any = React.useContext(AppContext);
  const { isUserLoggedIn, signinlink, firstName } = appState?.getCommonData?.CI_SigninSignupLinks || {};
  const signinURL = generateSignInLink(signinlink);

  const [userMenuDisplay, _setUserMenuDisplay] = useState('none');
  const displayRef = useRef(userMenuDisplay);

  const setUserMenuDisplay = (displayType: string) => {
    displayRef.current = displayType;
    _setUserMenuDisplay(displayType);
  };

  const toggleUserMenu = (event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null) => {
    if (displayRef.current === 'none') {
      setUserMenuDisplay('block');
      setHeaderClass('header-nav-menu-open sign-in-open');
    } else {
      setUserMenuDisplay('none');
      setHeaderClass('');
    }
  };

  useEffect(() => {
    document.addEventListener('mouseup', (e: MouseEvent) => {
      const el = e.target as HTMLElement;
      if (el.parentElement?.getAttribute('id') === 'dg-siso-dropdown' || el.getAttribute('id') === 'dg-siso-dropdown') {
        return;
      }
      if (displayRef.current !== 'none') {
        toggleUserMenu(null);
      }
    });
  }, []);

  return (
    <div className="mod mod-navtab aem-header__top-bar" role="navigation">
      <div className="aem-header-logo">
        <div
          data-cmp-src="https://cdn.cpnscdn.com/static.coupons.com/Sites/img/riq/dollargeneral/desktop-logo.png"
          data-asset="https://cdn.cpnscdn.com/static.coupons.com/Sites/img/riq/dollargeneral/desktop-logo.png"
          data-asset-id="42d77d4f-d916-4540-b291-5e35f972b81f"
          data-title="Dollar General Logo"
          className="cmp-image"
          itemScope
          itemType="http://schema.org/ImageObject"
        >
          <a className="cmp-image__link" href="https://www.dollargeneral.com/" data-cmp-hook-image="link">
            <img
              src="https://cdn.cpnscdn.com/static.coupons.com/Sites/img/riq/dollargeneral/desktop-logo.png"
              className="cmp-image__image"
              itemProp="contentUrl"
              data-cmp-hook-image="image"
              alt="Dollar General Logo"
            />
            <img
              src="https://cdn.cpnscdn.com/static.coupons.com/Sites/img/riq/dollargeneral/mobile-logo.png"
              className="cmp-image__image--mobile"
              itemProp="contentUrl"
              data-cmp-hook-image="image"
              alt="Dollar General Logo"
            />
          </a>
        </div>
      </div>
      <button type="button" className="aem-header__main-menu-toggle">
        Menu <span className="dg-icon dg-icon-chevron-down"></span>
      </button>
      <div className="aem-header__menu-wrapper">
        <button type="button" className="aem-header__main-menu-close-button">
          <span className="dg-icon dg-icon-close"></span>
        </button>
        <div className="aem-header-navigation">
          <nav className="navigation__menu-wrapper">
            <ul className="navigation__menu-list navTabMenu">
              <li className="navigation-menu">
                <a
                  className="navigation-menu__link navigation-menu__link--top"
                  target="_blank"
                  href="https://www.dollargeneral.com/dgpickup.html"
                  role="link"
                >
                  <img
                    alt="DG pickup logo"
                    src="https://cdn.cpnscdn.com/static.coupons.com/Sites/img/riq/dollargeneral/DG-pickup.png"
                    width="79"
                    height="19"
                  />
                </a>
              </li>
              <li className="navigation-menu">
                <a
                  aria-current="page"
                  className="navigation-menu__link navigation-menu__link--top gallery-nav active"
                  href="/coupons/"
                  role="link"
                >
                  <span className="nav-label">
                    Digital Coupons<span className="sr-only">Current page selected</span>
                  </span>
                </a>
              </li>
              <li className="navigation-menu">
                <a
                  aria-current
                  className="navigation-menu__link navigation-menu__link--top rewards-nav"
                  href="/rewards/"
                  role="link"
                >
                  <span className="nav-label">
                    DG Rewards<span className="sr-only"></span>
                  </span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <div className="aem-header-searchbar"></div>
        <div className="mod mod-signinsignuplinks aem-header-sign-in">
          {isUserLoggedIn ? (
            <>
              <button
                onClick={(event) => {
                  toggleUserMenu(event);
                }}
                id="dg-siso-dropdown"
                className="aem-header-sign-in__open-button"
              >
                <span className="dg-icon dg-icon-account"></span>
                <span
                  className="aem-header-sign-in__open-button-text"
                  data-sign-in-text="Sign in"
                  data-account-text="Account"
                >
                  {`Hi, ${firstName}!`}
                </span>
              </button>
              <div className="aem-header-sign-in__menu sign-in-sub" style={{ display: userMenuDisplay }}>
                <ul className="aem-header-sign-in__top-menu">
                  <li className="aem-header-sign-in-name">
                    <span className="aem-header-sign-in-name__initials"></span>
                    <span className="aem-header-sign-in-name__full-name"></span>
                  </li>
                  <li className="aem-header-sign-in__menu-link">
                    <a href="/settings/">
                      <span className="dg-icon dg-icon-account" aria-hidden="true"></span>
                      My account
                    </a>
                  </li>
                  <li className="aem-header-sign-in__menu-link">
                    <a href="/employeeSetting/">
                      <span className="dg-icon dg-icon-track-order" aria-hidden="true"></span>
                      Employee Info
                    </a>
                  </li>
                </ul>
                <ul className="aem-header-sign-in__bottom-menu">
                  <li className="aem-header-sign-in__menu-link">
                    <a href="/contact-preferences/">
                      <span className="dg-icon dg-icon-question" aria-hidden="true"></span>
                      Contact Preferences
                    </a>
                  </li>
                  <li className="aem-header-sign-in__menu-link">
                    <a href="/help/">
                      <span className="dg-icon dg-icon-question" aria-hidden="true"></span>
                      Get Help
                    </a>
                  </li>
                  <li className="aem-header-sign-in__menu-link">
                    <a href="//www.dollargeneral.com/terms-and-conditions" target="_blank">
                      <span className="dg-icon dg-icon-gift-card" aria-hidden="true"></span>
                      Terms & Conditions
                    </a>
                  </li>
                  <li className="aem-header-sign-in__menu-link">
                    <button type="button" className="sign-out aem-header-sign-in__log-out-button" onClick={signOut}>
                      <span className="dg-icon dg-icon-sign-out" aria-hidden="true"></span>
                      Sign out
                    </button>
                  </li>
                </ul>
              </div>
            </>
          ) : (
            <button
              className="aem-header-sign-in__open-button"
              onClick={() => {
                location.href = signinURL;
              }}
            >
              <span className="dg-icon dg-icon-account"></span>
              <span
                className="aem-header-sign-in__open-button-text"
                data-sign-in-text="Sign in"
                data-account-text="Account"
              >
                Sign in
              </span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default NavTab;
